import { useEffect, useState } from "react";
import { ethers } from "ethers";
import erc20Abi from "@/components/abi/erc20ABI.json";

const tokenAddress = "0x0A10D108E2d81ccC793E37b56206C84bF96ddc57"; // XSEED Token contract address

const provider = new ethers.providers.JsonRpcProvider("https://api.avax.network/ext/bc/C/rpc");

const useTokenBalance = (walletAddress) => {
  const [tokenBalance, setTokenBalance] = useState("0");
  const [tokenSymbol, setTokenSymbol] = useState("XSEED");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchTokenData = async () => {
      if (!walletAddress) return;

      setLoading(true);

      try {
        // Get token balance using RPC provider directly
        const balance = await getTokenBalance(walletAddress);
        setTokenBalance(balance);

        // Get token symbol
        const symbol = await getTokenSymbol();
        setTokenSymbol(symbol);
      } catch (error) {
        console.error("Error fetching token data:", error);
        setTokenBalance("0");
      }

      setLoading(false);
    };

    fetchTokenData();
  }, [walletAddress]);

  const getTokenBalance = async (userAddress) => {
    const contract = new ethers.Contract(tokenAddress, erc20Abi, provider);
    try {
      const balance = await contract.balanceOf(userAddress);

      const decimals = await contract.decimals();

      const formattedBalance = ethers.utils.formatUnits(balance, decimals);

      // If balance is 0, return "0" without decimals
      if (parseFloat(formattedBalance) === 0) return "0";

      // Otherwise format with commas and 2 decimal places
      const formattedWithCommas = parseFloat(formattedBalance).toLocaleString('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      });

      return formattedWithCommas;
    } catch (error) {
      console.error(`Error calling balanceOf on contract:`, error);
      throw error;
    }
  };

  const getTokenSymbol = async () => {
    const contract = new ethers.Contract(tokenAddress, erc20Abi, provider);
    try {
      const symbol = await contract.symbol();
      return symbol;
    } catch (error) {
      console.error(`Error calling symbol on contract:`, error);
      throw error;
    }
  };

  return { tokenBalance, tokenSymbol, loading };
};

export default useTokenBalance;
